import { createContext, useContext, useEffect, useState } from "react";

const LangCtx = createContext({ lang: "hi", setLang: () => {}, t: (en) => en });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sk_lang") || "hi");
  useEffect(() => {
    localStorage.setItem("sk_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (en, hi) => (lang === "hi" && hi ? hi : en);
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);

export function LangToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex rounded-full border border-slate-200 bg-white p-0.5 text-xs font-semibold ${className}`} data-testid="lang-toggle">
      {[["en", "EN"], ["hi", "हिंदी"]].map(([k, l]) => (
        <button
          key={k}
          data-testid={`lang-${k}`}
          onClick={() => setLang(k)}
          className={`rounded-full px-3 py-1 transition-colors ${lang === k ? "bg-[#0E1726] text-white" : "text-slate-600 hover:text-[#0E1726]"}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
